import { graphql } from "../gql";

export const setProviderSignOffClaimStatesMutationDoc = graphql(`
  mutation setProviderSignOffClaimStates(
    $input: SetProviderSignOffClaimStatesInput!
  ) {
    setProviderSignOffClaimStates(input: $input) {
      providerSignOffClaimStates {
        batchClaim {
          batchClaimStateById {
            claimAuditType
            clientSignOffClaimState
            determinedAdjustedAllowedAmount
            determinedClientSavings
            determinedDiscrepantAmount
            disputedFindingClaimState
            documentationClaimState
            id
            invoiceClaimState
            isProviderActive
            isRealized
            negotiationClaimState
            onHoldClaimState
            potentialAdjustedAllowedAmount
            potentialClientSavings
            potentialDiscrepantAmount
            providerSignOffClaimState
            reported
            workflowClaimState
          }
          id
        }
      }
    }
  }
`);
